import { useState } from "react";
import { Link } from "react-router-dom";
import { ChevronDown } from "lucide-react";
import { useNavbar } from "../../hooks/useNavbar";

interface CatalogDropdownProps {
  className?: string;
}

export function CatalogDropdown({ className = "" }: CatalogDropdownProps) {
  const [isOpen, setIsOpen] = useState(false);
  const { data: navbarData, isLoading } = useNavbar();

  const handleMouseEnter = () => {
    setIsOpen(true);
  };

  const handleMouseLeave = () => {
    setIsOpen(false);
  };

  return (
    <div
      className={`relative ${className}`}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {/* Área invisible para crear puente entre trigger y menú */}
      {isOpen && (
        <div className="absolute top-full left-0 right-0 h-1 bg-transparent" />
      )}
      {/* Trigger del dropdown */}
      <button className="flex items-center text-gray-700 hover:text-gray-900 px-3 py-2 text-sm font-medium transition-colors duration-200">
        Catálogos
        <ChevronDown className="ml-1 h-4 w-4" />
      </button>

      {/* Dropdown menu */}
      {isOpen && (
        <div className="absolute top-full left-0 w-64 bg-white border border-gray-200 rounded-md shadow-lg z-50">
          <div className="py-1">
            {isLoading ? (
              <div className="px-4 py-2 text-sm text-gray-500">
                Cargando catálogos...
              </div>
            ) : navbarData?.catalogs && navbarData.catalogs.length > 0 ? (
              navbarData.catalogs.map((catalog) => (
                <Link
                  key={catalog.id}
                  to={`/catalog/${catalog.slug}`}
                  state={{ categories: catalog.categories }}
                  className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-gray-900 transition-colors duration-150"
                  onClick={() => setIsOpen(false)}
                >
                  {catalog.name}
                </Link>
              ))
            ) : (
              <div className="px-4 py-2 text-sm text-gray-500">
                No hay catálogos disponibles
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
